import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { MoreVertical, Download, Check } from "lucide-react";

export const AndroidInstallDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm" data-testid="android-install-dialog">
      <DialogHeader>
        <DialogTitle className="font-head">Installa K9 Manager</DialogTitle>
        <DialogDescription>Per aggiungere K9 Manager alla schermata Home:</DialogDescription>
      </DialogHeader>
      <ol className="space-y-3 text-sm">
        <li className="flex items-center gap-3">
          <span className="grid place-items-center h-8 w-8 rounded-lg bg-secondary text-foreground shrink-0"><MoreVertical className="h-4 w-4" /></span>
          <span>Apri il menu <b>⋮</b> di Chrome</span>
        </li>
        <li className="flex items-center gap-3">
          <span className="grid place-items-center h-8 w-8 rounded-lg bg-secondary text-foreground shrink-0"><Download className="h-4 w-4" /></span>
          <span>Scegli <b>“Installa e crea scorciatoia”</b></span>
        </li>
        <li className="flex items-center gap-3">
          <span className="grid place-items-center h-8 w-8 rounded-lg bg-secondary text-foreground shrink-0"><Check className="h-4 w-4" /></span>
          <span>Tocca <b>“Installa”</b></span>
        </li>
      </ol>
    </DialogContent>
  </Dialog>
);
